__turbopack_context__.v({
  "Button": "PrimaryButton-module-scss-module__F6qrMa__Button",
  "Loader": "PrimaryButton-module-scss-module__F6qrMa__Loader",
  "PrimaryButton": "PrimaryButton-module-scss-module__F6qrMa__PrimaryButton",
  "Text": "PrimaryButton-module-scss-module__F6qrMa__Text",
  "spin": "PrimaryButton-module-scss-module__F6qrMa__spin",
});
